import { actions, types } from './requests'
export const GETBLACKBOXLIST_TYPES = {
    ...types('GETBLACKBOXLIST'),
}
export const GETBLACKBOXLIST_ACTIONS = {
    ...actions('GETBLACKBOXLIST'),
}
